import { AppDomainConfig } from "../../envConfig";
import { IndustryEnum } from "../../types/api-schema";
import {
  MAPSET_LAYOUT_DESCRIPTION,
  MAPSET_LAYOUT_FILENAME,
  MAPSET_LAYOUT_TITLE,
} from "../../utils/constants";

import colors from "./colors";
import iconCategories from "./icons.json";

const config: Partial<AppDomainConfig> = {
  domains: ["ch"],
  font: '16px "FrutigerLTStd-Light", sans-serif',
  iconCategories,
  id: "asm", // needs to be identical to the icons directory name in public
  industry: IndustryEnum.Transport,
  layoutConfigs: {
    aare_seeland_ersatzverkehr_bahn: {
      [MAPSET_LAYOUT_DESCRIPTION]: {
        defaultValue: () => {
          return "Bei einem Streckenunterbruch können Ersatzbusse verkehren. Der Einsatz von Ersatzbussen wird am Bildschirm angezeigt. Bitte begeben Sie sich zum Halteort EV Ersatzverkehr.";
        },
        name: (t) => {
          return t("mapset_layout_description");
        },
        placeholder: (t) => {
          return t("mapset_layout_description_placeholder");
        },
        position: 2,
        type: "html",
      },
      [MAPSET_LAYOUT_FILENAME]: {
        defaultValue: () => {
          return "Ersatzhaltestelle_Bahn_A4h";
        },
        type: "filename",
      },
      [MAPSET_LAYOUT_TITLE]: {
        defaultValue: () => {
          return "Ihr Weg zur Ersatzhaltestelle bei Ersatzverkehr";
        },
        name: (t) => {
          return t("mapset_layout_title");
        },
        placeholder: (t) => {
          return t("mapset_layout_title_placeholder");
        },
        position: 1,
        type: "text",
      },
    },
    aare_seeland_ersatzverkehr_bus: {
      [MAPSET_LAYOUT_FILENAME]: {
        defaultValue: () => {
          return "Aushang_Bus_A3q";
        },
        type: "filename",
      },
    },
  },
  name: "Aare Seeland Mobil",
  slug: "asm",
  ...colors,
};
export default config;
